import React from 'react';
import './CalculusOfMeaning.css';

function PageHero({ label, title, subtitle }) {
  return (
    <div className="calculus-hero">
      <div className="calculus-hero-video-wrapper">
        <video autoPlay muted playsInline className="calculus-hero-video" loop poster="/assets/calculus-hero-poster.jpg" preload="auto">
          <source src="/assets/calculus-hero.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="calculus-hero-overlay" />
      <div className="calculus-hero-content">
        {label && <span className="calculus-hero-label">{label}</span>}
        <h1>{title}</h1>
        {subtitle && <p className="calculus-hero-sub">{subtitle}</p>}
      </div>
    </div>
  );
}

export default PageHero;
